import { useMemo } from 'react';

import { demoWoopWorkloadNativeVpaSpec } from '@cast/fixtures';

import { useIsWoopDemoMode } from 'features/workload-optimization';
import {
  UseWorkloadNativeVpaSpecQueryArgs,
  useWorkloadNativeVpaSpecQuery,
} from 'hooks/queries/workload-optimization';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

export const useWoopWorkloadNativeVpaSpec = (
  queryArgs: UseWorkloadNativeVpaSpecQueryArgs
) => {
  const isWoopDemoMode = useIsWoopDemoMode();

  const queryResult = useWorkloadNativeVpaSpecQuery({
    ...queryArgs,
    enabled: !isWoopDemoMode && queryArgs.enabled,
  });

  const demoWorkloadsFixture = useMemo(
    () => () =>
      demoWoopWorkloadNativeVpaSpec().then((fixture) => {
        const workloadId = queryArgs.workloadId;
        return fixture.find(({ id }) => id === workloadId);
      }),
    [queryArgs.workloadId]
  );

  const workloadDataOrFixture = useDataOrFixture(
    queryResult.data,
    demoWorkloadsFixture,
    isWoopDemoMode
  );

  return { ...queryResult, data: workloadDataOrFixture };
};
